// extracted by mini-css-extract-plugin
export default {"tableParent":"Restriction_tableParent__hcsL5","header":"Restriction_header__pVjCW","ant-table":"Restriction_ant-table__X0g-7"};